
import {API_SERVER_MONITOR} from '@/enmus/PageNames';
export default {
    // vue-cli对api前缀做了特殊处理，需要加_做区分
    path: '_apiServerMonitor',
    name: API_SERVER_MONITOR,
    component: () => import('@/views/dataReport/apiServerMonitor/index.vue'),
    meta: {
        name: API_SERVER_MONITOR,
        title: 'API-服务报表'
    }
};